import { SidekickSupportedTms } from '@shared/generated/graphql';
import { EntityInfo, SupportedEntityType, TMSPageInfo } from './types';

const PREFIX = 'MercuryGate/transport';

const LOAD_DETAILS_PATH = `${PREFIX}/editTransportOrig.jsp`;
const TRANSPORT_PLAN_PATH = `${PREFIX}/editPlanDetail.jsp`;

export function getMercuryGateShipmentUrls(
  parentUrl: string,
  referenceNumber: string
): string[] {
  const baseUrl = new URL(parentUrl).origin;

  // TODO(jacob): Every load we've checked so far has had this 3300, but not
  // sure if this is guaranteed. Figure out where it comes from.
  const resource = `sidTransport=(${referenceNumber},3300,0)`;

  return [
    `${baseUrl}/${LOAD_DETAILS_PATH}?${resource}`,
    `${baseUrl}/${TRANSPORT_PLAN_PATH}?${resource}`,
  ];
}

export function getMercuryGatePageInfo(url: string): TMSPageInfo {
  return {
    pageType: 'tms',
    tms: SidekickSupportedTms.MERCURYGATE,
    entityInfo: getEntityInfo(url),
  };
}

function getEntityInfo(url: string): EntityInfo[] {
  // NOTE(mike): For now, we look for one entity at a time.
  const shipmentPattern = /details\/[\w]+\/(\d+)/;
  const shipmentMatch = url.match(shipmentPattern);
  if (shipmentMatch) {
    return [
      {
        entityType: SupportedEntityType.SHIPMENT,
        entityReference: shipmentMatch[1],
      },
    ];
  }
  return [];
}
